type BreadcrumbType = {
  name: string
  link: string
}[]

export const CODING_FOR_KIDS_ITEMS: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Coding for kids',
    link: '/coding-for-kids/',
  },
]
export const COURSES_ITEMS: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: '/courses/',
  },
]

const PYTHON_FOR_KIDS: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Python Champion',
    link: '/courses/python-for-kids/',
  },
]

const SCRATCH_PROGRAMMING: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Scratch Programming with AI',
    link: '/courses/scratch-programming/',
  },
]
const ROBLOX: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Roblox Champion',
    link: '/courses/roblox/',
  },
]
const AP_COMPUTER_SCIENCE_A: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'AP Computer Science A',
    link: '/courses/ap-computer-science-a/',
  },
]
const HPE_CODEWARS_CODE_BATTLE: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'HPE CodeWars Code Battle',
    link: '/courses/hpe-codewars-code-battle/',
  },
]
const HPE_CODEWARS_HACKATHON: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'HPE CodeWars Hackathon',
    link: '/courses/hpe-codewars-hackathon/',
  },
]
const AI_AND_ML: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'AI and Machine Learning',
    link: '/courses/artificial-intelligence-and-machine-learning/',
  },
]
const THUNKABLE: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Thunkable',
    link: '/courses/thunkable/',
  },
]
const JAVA: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Java',
    link: '/courses/java/',
  },
]

const TRINKET: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Trinket',
    link: '/courses/trinket/',
  },
]

const PYGAME: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Pygame',
    link: '/courses/pygame/',
  },
]

const ANIMATION: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Animation',
    link: '/courses/animation/',
  },
]
const TURTLE: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Turtle',
    link: '/courses/turtle-graphics-for-kids/',
  },
]

const MIT_APP_INVENTOR: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'MIT App Inventor',
    link: '/courses/mit-app-inventor-for-kids/',
  },
]

const BOOTSTRAP: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Bootstrap',
    link: '/courses/bootstrap-web-design-for-kids/',
  },
]
const JAVASCRIPT: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'JavaScript',
    link: '/courses/learn-javascript-for-kids-and-teens/',
  },
]
const CSS: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'CSS for Kids',
    link: '/courses/css-for-kids/',
  },
]
const HTML: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'HTML for Kids',
    link: '/courses/html-for-kids/',
  },
]
const AICODE101: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'AI Code 101 for Kids',
    link: '/courses/ai-code-101-for-kids/',
  },
]
const CODE_ORG: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Code.org Courses for Kids',
    link: '/courses/code-org-courses-for-kids/',
  },
]
const PICTOBLOX: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'PictoBlox',
    link: '/courses/pictoblox/',
  },
]
const TEACHABLE_MACHINE: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Teachable Machine for Kids',
    link: '/courses/teachable-machine/',
  },
]
const GOOGLE_COLAB: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Google Colab for Kids',
    link: '/courses/google-colab-for-kids/',
  },
]
const NODE_JS: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Node.js',
    link: '/courses/node-js/',
  },
]
const VISUAL_STUDIO_CODE: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Visual Studio Code',
    link: '/courses/visual-studio-code/',
  },
]
const SQL: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'SQL for Kids',
    link: '/courses/sql/',
  },
]
const REACT_JS: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'React.Js for Kids',
    link: '/courses/reactjs-for-kids/',
  },
]
const GIT: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'GIT for Kids',
    link: '/courses/git-for-kids/',
  },
]
const GITHUB: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Github for Kids',
    link: '/courses/github-for-kids/',
  },
]
const PUBLIC_SPEAKING_GRADE_3_5: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Public Speaking for Kids',
    link: '/courses/public-speaking-for-kids/',
  },
  {
    name: 'Grade 3-5',
    link: '/courses/public-speaking-for-kids/grade-3-5/',
  },
]
const PUBLIC_SPEAKING_GRADE_1_2: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Courses',
    link: 'https://www.codingal.com/courses/',
  },
  {
    name: 'Public Speaking for Kids',
    link: '/courses/public-speaking-for-kids/',
  },
  {
    name: 'Grade 1-2',
    link: '/courses/public-speaking-for-kids/grade-1-2/',
  },
]
const CODING_GRADE_1_3: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Coding for kids',
    link: '/coding-for-kids/',
  },
  {
    name: 'Coding for grades 1-3',
    link: '/coding-for-kids/grade-1-3/',
  },
]
const CODING_GRADE_4_5: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Coding for kids',
    link: '/coding-for-kids/',
  },
  {
    name: 'Coding for grades 4-5',
    link: '/coding-for-kids/grade-4-5/',
  },
]
const CODING_GRADE_6_8: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Coding for kids',
    link: '/coding-for-kids/',
  },
  {
    name: 'Coding for grades 6-8',
    link: '/coding-for-kids/grade-6-8/',
  },
]
const CODING_GRADE_9_10: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Coding for kids',
    link: '/coding-for-kids/',
  },
  {
    name: 'Coding for grades 9-10',
    link: '/coding-for-kids/grade-9-10/',
  },
]
const CODING_GRADE_11_12: BreadcrumbType = [
  {
    name: 'Codingal',
    link: '/',
  },
  {
    name: 'Coding for kids',
    link: '/coding-for-kids/',
  },
  {
    name: 'Coding for grades 11-12',
    link: '/coding-for-kids/grade-11-12/',
  },
]
export const COURSES_BREADCRUMB = {
  PYTHON_FOR_KIDS,
  SCRATCH_PROGRAMMING,
  ROBLOX,
  AP_COMPUTER_SCIENCE_A,
  HPE_CODEWARS_CODE_BATTLE,
  HPE_CODEWARS_HACKATHON,
  AI_AND_ML,
  THUNKABLE,
  JAVA,
  TRINKET,
  PYGAME,
  ANIMATION,
  TURTLE,
  MIT_APP_INVENTOR,
  BOOTSTRAP,
  JAVASCRIPT,
  CSS,
  HTML,
  AICODE101,
  CODE_ORG,
  PICTOBLOX,
  TEACHABLE_MACHINE,
  GOOGLE_COLAB,
  NODE_JS,
  VISUAL_STUDIO_CODE,
  SQL,
  REACT_JS,
  GIT,
  GITHUB,
  PUBLIC_SPEAKING_GRADE_3_5,
  PUBLIC_SPEAKING_GRADE_1_2,
  CODING_GRADE_1_3,
  CODING_GRADE_4_5,
  CODING_GRADE_6_8,
  CODING_GRADE_9_10,
  CODING_GRADE_11_12,
}
